import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "@/lib/site";
import AmazonButton from "@/components/AmazonButton";

const linkClass = ({ isActive }) =>
  `text-sm font-medium transition-colors duration-200 ${
    isActive
      ? "text-[#1F6FEB]"
      : "text-[#263238] hover:text-[#1F6FEB]"
  }`;

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-50 w-full border-b border-[#0B1F33]/10 bg-white/95 backdrop-blur-md"
    >
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-3 focus:z-50 focus:rounded-md focus:bg-[#0B1F33] focus:px-4 focus:py-2 focus:text-sm focus:text-white"
      >
        Skip to main content
      </a>
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
        {/* Text-based logo. Replace this block with an <img> when an official logo file is available. */}
        <Link
          to="/"
          data-testid="site-logo"
          className="flex items-baseline gap-[2px] font-[Manrope] text-xl font-extrabold tracking-tight text-[#0B1F33]"
          aria-label="AutoNeova home"
        >
          Auto<span className="text-[#1F6FEB]">Neova</span>
          <span className="ml-1 h-[6px] w-[6px] rounded-sm bg-[#D72638]" aria-hidden="true" />
        </Link>

        <nav aria-label="Main navigation" className="hidden items-center gap-9 lg:flex">
          {NAV_LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} className={linkClass} data-testid={l.testId} end={l.to === "/"}>
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <AmazonButton testId="header-amazon-cta" className="px-5 py-2.5" />
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? "Close menu" : "Open menu"}
          className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-[#0B1F33]/15 text-[#0B1F33] lg:hidden"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <nav
          id="mobile-nav"
          aria-label="Mobile navigation"
          data-testid="mobile-nav"
          className="border-t border-[#0B1F33]/10 bg-white px-5 pb-6 pt-2 lg:hidden"
        >
          <ul className="flex flex-col">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  data-testid={`mobile-${l.testId}`}
                  className="block border-b border-[#F4F6F8] py-4 text-base font-medium text-[#263238]"
                >
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>
          <AmazonButton testId="mobile-amazon-cta" className="mt-6 w-full" />
        </nav>
      )}
    </header>
  );
};

export default Header;
